import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { Link, router } from '@inertiajs/react'
import { SidebarLayout } from '@/components/layouts/SidebarLayout'

interface GrantRequest {
  id: number
  agent_username: string
  secret_name: string
  reason: string
  status: 'pending' | 'approved' | 'denied'
  created_at: string
}

interface Props {
  grant_requests: GrantRequest[]
}

const statusColors: Record<string, 'warning' | 'success' | 'error'> = {
  pending: 'warning',
  approved: 'success',
  denied: 'error',
}

export default function GrantRequests({ grant_requests }: Props) {
  function handleApprove(id: number) {
    router.post(`/manage/secrets/grant_requests/${id}/approve`)
  }

  function handleDeny(id: number) {
    router.post(`/manage/secrets/grant_requests/${id}/deny`)
  }

  return (
    <SidebarLayout section="manage" title="Grant requests">
      <Box sx={{ mb: 3 }}>
        <Link href="/manage/secrets" style={{ color: '#1a1a1a' }}>Back to secrets</Link>
      </Box>
      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider', overflowX: 'auto' }}>
        <Table sx={{ minWidth: 600 }}>
          <TableHead>
            <TableRow>
              <TableCell>Agent</TableCell>
              <TableCell>Secret</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {grant_requests.map((gr) => (
              <TableRow key={gr.id}>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {gr.agent_username}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                    {gr.secret_name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {gr.reason}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={gr.status}
                    size="small"
                    color={statusColors[gr.status] || 'default'}
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {new Date(gr.created_at).toLocaleDateString()}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  {gr.status === 'pending' && (
                    <>
                      <Button size="small" color="success" onClick={() => handleApprove(gr.id)} sx={{ mr: 1 }}>
                        Approve
                      </Button>
                      <Button size="small" color="error" onClick={() => handleDeny(gr.id)}>
                        Deny
                      </Button>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {grant_requests.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="body2" color="text.secondary" sx={{ py: 4 }}>
                    No grant requests found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </SidebarLayout>
  )
}
